import { render } from "./CallQueuesHeader.vue?vue&type=template&id=6271f962"
import script from "./CallQueuesHeader.vue?vue&type=script&lang=js"
export * from "./CallQueuesHeader.vue?vue&type=script&lang=js"

import "./CallQueuesHeader.vue?vue&type=style&index=0&id=6271f962&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__